import _ from 'lodash';

export const useChartData = (
  data: Record<string, number>,
  colors: string[],
) => {
  const labels = Object.entries(data)
    .filter(([, value]) => value > 0)
    .map(([status]) => status);

  const chartDatasets = labels.map(label => _.get(data, `${label}`, 0));

  const totalData = Object.values(data).reduce((sum, value) => sum + value, 0);

  const labelColorPairs = labels.map((label, index) => ({
    label,
    color: colors[index],
  }));

  return {
    chartData: {
      labels,
      datasets: [
        {
          data: chartDatasets,
          backgroundColor: colors,
        },
      ],
    },
    totalData,
    labelColorPairs,
  };
};
